import React from 'react';
import PreviewModal from '~/src/components/Modal/PreviewModal';

interface LicenseQuantityPreviewModalProps {
  previewData: any;
  newLicenseQuantity: number;
  currentLicenseQuantity: number;
  onCancel: () => void;
  onConfirm: () => void;
  isProcessing: boolean;
}

export const LicenseQuantityPreviewModal = ({
  previewData,
  newLicenseQuantity,
  currentLicenseQuantity,
  onCancel,
  onConfirm,
  isProcessing,
}: LicenseQuantityPreviewModalProps) => {
  const isIncrease = newLicenseQuantity > currentLicenseQuantity;
  const invoiceData = previewData?.preview?.preview?.data;
  const { immediate_invoice, recurring_invoice } = invoiceData || {};

  const changeDescription = `(${
    isIncrease ? 'Increasing' : 'Decreasing'
  } by ${Math.abs(newLicenseQuantity - currentLicenseQuantity)} license${
    Math.abs(newLicenseQuantity - currentLicenseQuantity) !== 1 ? 's' : ''
  })`;

  const importantNotes = [
    isIncrease
      ? 'Changes to your license count will be reflected on your Clio subscription and billed with immediate effect.'
      : 'Changes to your license count will be reflected on your Clio subscription and billed at the end of your current billing cycle.',
  ];

  return (
    <PreviewModal
      title={`${isIncrease ? 'Increase' : 'Decrease'} License Quantity`}
      onCancel={onCancel}
      onConfirm={onConfirm}
      isProcessing={isProcessing}
      confirmText={`Confirm ${isIncrease ? 'Increase' : 'Decrease'}`}
      cancelText="Cancel"
      confirmDisabled={!previewData}
      beforeAfterState={{
        currentLabel: 'Current Quantity',
        newLabel: 'New Quantity',
        currentValue: currentLicenseQuantity.toString(),
        newValue: newLicenseQuantity.toString(),
        changeDescription,
      }}
      invoiceSection={{
        immediateInvoice: immediate_invoice,
        recurringInvoice: recurring_invoice,
      }}
      importantNotes={importantNotes}
    />
  );
};
